import WebAnimation from './WebAnimation' ;

export default function tween(obj, options) {
    options  = options || {}
    if (typeof options.to === void 0) {
        throw('cannot create a tween witout values', obj)
    }
    let startValues = {}
    for (let k in options.to) {
        startValues[k] = obj[k];
    }
    let t = new WebAnimation({
        step: (e)=>{
            for (let k in options.to) {
                obj[k] = startValues[k] + (options.to[k]-startValues[k]) * e
            }
            options.step && options.step(e)
        },
        end:        options.end,
        delay:      options.delay    * 1000,
        duration:   options.duration * 1000,
        easing:     options.easing
    });
    t.play();
    return t;
}